import { render } from "./ClassicCase.vue?vue&type=template&id=7ec0ab29"
import script from "./ClassicCase.vue?vue&type=script&lang=js"
export * from "./ClassicCase.vue?vue&type=script&lang=js"

import "./ClassicCase.vue?vue&type=style&index=0&id=7ec0ab29&lang=scss"

import exportComponent from "D:\\xampp\\htdocs\\JuHui\\ju-hui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__